"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HabitStates = void 0;
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
var HabitStates;
(function (HabitStates) {
    HabitStates[HabitStates["ACTIVE"] = 0] = "ACTIVE";
    HabitStates[HabitStates["COMPLETE"] = 1] = "COMPLETE";
    HabitStates[HabitStates["LOCKED"] = 2] = "LOCKED";
    HabitStates[HabitStates["WAITING"] = 3] = "WAITING";
})(HabitStates = exports.HabitStates || (exports.HabitStates = {}));
class AccountHabit extends base_1.default {
    constructor(data = {
        id: undefined,
        habit_id: undefined,
        segments: [],
        date_completed: undefined,
        commitment_end: undefined,
        unlocked_manually: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.habit_id = (0, defaults_1.defaultString)(data.habit_id);
        this.segments = (0, defaults_1.defaultArray)(data.segments);
        this.date_completed = data.date_completed;
        this.commitment_end = data.commitment_end;
        this.unlocked_manually = (0, defaults_1.defaultBoolean)(data.unlocked_manually);
    }
    get dateCompleted() {
        return this.date_completed;
    }
    get dateCommitmentEnd() {
        return this.commitment_end;
    }
    get unlockedManually() {
        return this.unlocked_manually;
    }
    get getStatus() {
        if (this.dateCompleted) {
            return HabitStates.COMPLETE;
        }
        return HabitStates.ACTIVE;
    }
}
exports.default = AccountHabit;
